module.exports = __webpack_public_path__ + "img/007.1b1c595a.png";